import React, { useState } from 'react';
import UISectionWrapper, {
  UISectionHeader,
  UISectionBody,
  UISectionFooter,
} from '@/components/shared/UISectionWrapper';
import UISectionTitle from '@/components/shared/UISectionTitle';
import UIInput from '@/components/shared/UIInput';
import UISelect from '@/components/shared/UISelect';
import UICheckbox from '@/components/shared/UICheckbox';
import UIButton from '@/components/shared/UIButton';
import './TwoStepVerificationSection.scss';

export interface TwoStepVerificationSectionProps {
  /**
   * Додатковий CSS клас
   */
  className?: string;
}

// Моковые данные для країн
const countryCodeOptions = [
  { value: '+380', label: '+380' },
  { value: '+1', label: '+1' },
  { value: '+44', label: '+44' },
  { value: '+49', label: '+49' },
];

const baseClass = 'TwoStepVerificationSection';

const TwoStepVerificationSection: React.FC<TwoStepVerificationSectionProps> = ({
  className = '',
}) => {
  // Стан для чекбокса
  const [rememberMe, setRememberMe] = useState(false);

  // Стан для кодів верифікації (6 цифр)
  const [verificationCodes, setVerificationCodes] = useState([
    '',
    '',
    '',
    '',
    '',
    '',
  ]);

  // Обробник для чекбокса
  const handleRememberMeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRememberMe(event.target.checked);
    console.log('Remember me for 30 days:', event.target.checked);
  };

  // Обробник для кодів верифікації
  const handleCodeChange =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value.slice(0, 1); // Тільки один символ
      const newCodes = [...verificationCodes];
      newCodes[index] = value;
      setVerificationCodes(newCodes);

      // Автоматичний перехід до наступного поля
      if (value && index < 5) {
        const nextInput = document.querySelector(
          `.${baseClass}__code-input:nth-child(${index + 2}) input`,
        ) as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
      }
    };

  return (
    <UISectionWrapper className={`${baseClass} ${className}`} align="stretch">
      <UISectionHeader>
        <UISectionTitle
          title="Two-step verification"
          description="You must setup a two factor authentication to go online with our security guidelines."
        />
      </UISectionHeader>

      <UISectionBody>
        {/* Add Phone Number Section */}
        <div className={`${baseClass}__section`}>
          <h3 className={`${baseClass}__section-title`}>Add Phone Number</h3>

          <div className={`${baseClass}__phone-row`}>
            <UISelect
              options={countryCodeOptions}
              placeholder="+380"
              className={`${baseClass}__country-select`}
            />
            <UIInput
              placeholder="Phone Number"
              className={`${baseClass}__phone-input`}
              fullWidth
            />
          </div>
        </div>

        {/* Buttons for first section */}
        <div className={`${baseClass}__buttons`}>
          <UIButton variant="primary">Save</UIButton>
          <UIButton variant="primary" outline>
            Clear
          </UIButton>
        </div>

        {/* Divider */}
        <div className={`${baseClass}__divider`}></div>

        {/* 2 Step Verification Section */}
        <div className={`${baseClass}__section`}>
          <h3 className={`${baseClass}__section-title`}>2 Step Verification</h3>

          {/* Verification codes */}
          <div className={`${baseClass}__code-row`}>
            {verificationCodes.map((code, index) => (
              <UIInput
                key={index}
                value={code}
                onChange={handleCodeChange(index)}
                className={`${baseClass}__code-input`}
                maxLength={1}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            ))}
          </div>

          {/* Remember me checkbox */}
          <div className={`${baseClass}__checkbox-row`}>
            <UICheckbox
              value="remember-me"
              label="Remember me for 30 days"
              checked={rememberMe}
              onChange={handleRememberMeChange}
            />
          </div>

          {/* Help link */}
          <div className={`${baseClass}__help-link`}>
            I need help getting my verification code.
          </div>
        </div>
      </UISectionBody>

      <UISectionFooter>
        <div className={`${baseClass}__buttons`}>
          <UIButton variant="primary">Verify</UIButton>
          <UIButton variant="primary" outline>
            Cancel
          </UIButton>
        </div>
      </UISectionFooter>
    </UISectionWrapper>
  );
};

export default TwoStepVerificationSection;
